import styled from 'styled-components';

import {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  pSmall,
  pSmallGray,
  pNormal,
  pLarge,
} from 'styles/variables';

export const H1 = styled.h1`
  ${h1}
`;

export const H2 = styled.h2`
  ${h2}
`;

export const H3 = styled.h3`
  ${h3}
`;

export const H4 = styled.h4`
  ${h4}
`;

export const H5 = styled.h5`
  ${h5}
`;

export const H6 = styled.h6`
  ${h6}
`;

export const LargeParagraph = styled.p`
  ${pLarge}
`;

export const Paragraph = styled.p`
  ${pNormal}
`;

// export const ParagraphGray = styled.p`
//   ${pNormalGray}
// `;

export const ParagraphSmallGray = styled.p`
  ${pSmallGray}
`;

export const ParagraphSmall = styled.p`
  ${pSmall}
`;
